import { WorkflowItem } from '@cibo/core'
import { Loading, useWindowTitle } from '@cibo/profile'
import { useProgram, useWorkflows } from '@cibo/programs'
import { ListCard, Markdown } from '@cibo/ui'
import { Box, Button, Stack } from '@mui/material'
import { GridRowParams } from '@mui/x-data-grid-pro'
import { EnrollmentList } from 'components'
import { EngagementImpossible } from 'components/EngagementImpossible'
import { PROGRAM_ROUTES } from 'navigation/types/routes'
import { useTranslation } from 'react-i18next'
import { Link, Navigate, generatePath, useNavigate, useParams } from 'react-router-dom'

export const ProgramEnrollments = () => {
  const { t } = useTranslation('impact/pages/ProgramEnrollments')
  const { programId = '' } = useParams()
  const program = useProgram({ programId })
  useWindowTitle(program.data?.content.fields.title)
  const navigate = useNavigate()

  const enrollments = useWorkflows(0, 1000, {
    benchmark: ['enrollment'],
    programId,
  })

  if (!enrollments.isFetched || !program.isFetched) {
    return <Loading />
  }

  // no enrollments, some eligible fields
  if (!enrollments.data?.numAvailable) {
    if (
      !!program.data?.opportunitiesByWfStatus?.notInWorkflow &&
      !!program.data?.opportunitiesByWfStatus?.notInWorkflow[0]?.numResources
    ) {
      return (
        <Stack>
          <Box maxWidth={500}>
            <Markdown color="text.secondary">
              {t('eligibleFieldsCTAMd', { count: program.data.opportunities[0].numResources })}
            </Markdown>
          </Box>
          <Box>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              component={Link}
              to={generatePath(PROGRAM_ROUTES.FIELDS_ELIGIBLE, { programId })}
            >
              {t('seeEligible')}
            </Button>
          </Box>
        </Stack>
      )
    } else {
      return program.data?.enrollmentWindow.enrollmentStatus === 'closed' ? (
        <Navigate to={generatePath(PROGRAM_ROUTES.ABOUT, { programId })} replace />
      ) : (
        <EngagementImpossible programId={programId} />
      )
    }
  }

  return (
    <ListCard title={t('programs')} subTitle={t('openEnrollments')}>
      <EnrollmentList
        rows={
          enrollments.data?.items.map(item => ({
            ...item,
            programContent: program.data?.content,
          })) || ([] as WorkflowItem[])
        }
        onRowClick={({ id, row: { programId } }: GridRowParams<WorkflowItem>) => {
          navigate(
            generatePath(PROGRAM_ROUTES.ENROLL_DETAIL, { programId, workflowId: id as string })
          )
        }}
        hideProgramLogo
        hideProgramTitle
      />
    </ListCard>
  )
}
